export const CONTENT_CARD_READ_UNTIL_DATE_TIME_FORMAT = "MMM DD";

export const CONTENT_TYPES_LABELS = {
  ARTICLE: "Article",
  INTERACTIVE_VIDEO: "Interactive video",
  BUNDLE: "Text set",
  WORKSHEET: "Worksheet",
};

export const ARTICLE_STORY_MAP: { [key: string]: string } = {
  ARTICLE_INFORMATION: "Information",
  ARTICLE_EDITORIAL: "Editorial",
  ARTICLE_NEWS: "News",
  ARTICLE_FICTION: "Fiction",
  ARTICLE_POEM: "Poetry",
};

export const DISABLED_ASSIGNMENT_ACTIONS_TEXT_SET_TYPES: {
  [key: string]: string;
} = {
  Unit: "Unit",
  Row: "Row",
  Collection: "Collection",
  Module: "Module",
  Topics: "Topics",
};
